import axios from 'axios';
const routeName = `/guest-categories`;

export async function updateGuestCategories(data: any[],siteId: number|undefined): Promise<any> {
    const successData: any[] = [];
    const errorData: any[]= [];
    const questionsToUpdate: any[] = [];

    for (const guestCategory of data){        
        if (guestCategory.id){
            const where = { id: guestCategory.id};
            if (guestCategory.updatedAt) delete guestCategory.updatedAt;
            if (guestCategory.createdAt) delete guestCategory.createdAt;
            if (guestCategory.questions){
                for (const q of guestCategory.questions){
                    q.guestCategoryId = guestCategory.id;
                    questionsToUpdate.push(q);
                }
                delete guestCategory.questions;
            }

            await axios.patch(process.env.VUE_APP_CJ_API_URL +'/sites/' + siteId 
            + routeName + '?where='+JSON.stringify(where),guestCategory)
                .then(resp => {
                    successData.push(resp.data);
                })
                .catch(err => {
                    console.log('error patchGuestategories !',err);
                    errorData.push(err);
                });
        }else {
            let tempQuestions: any[] = [];
            if (guestCategory.questions){
                tempQuestions = guestCategory.questions;
                delete guestCategory.questions;
            }
            await axios.post(process.env.VUE_APP_CJ_API_URL +'/sites/' + siteId + routeName,guestCategory)
            .then(resp => {
                for (const question of tempQuestions){
                    question.guestCategoryId = resp.data.id;
                    questionsToUpdate.push(question);
                }
                successData.push(resp.data);
            })
            .catch(err => {
                console.log('error postGuestategories !',err);
                errorData.push(err);
            });
        }
    }

    //update or create question
    for (const questionData of questionsToUpdate){
        if (questionData.id){
            if (questionData.updatedAt) delete questionData.updatedAt;
            if (questionData.createdAt) delete questionData.createdAt;
            await axios.patch(process.env.VUE_APP_CJ_API_URL +'/questions/' + questionData.id 
            ,questionData)
                .then(resp => {
                    successData.push(resp.data);
                })
                .catch(err => {
                    console.log('error patchGuestategories patch answer !',err);
                    errorData.push(err);
                });
        }else {
            await axios.post(process.env.VUE_APP_CJ_API_URL +'/questions',questionData)
            .then(resp => {
                successData.push(resp.data);
            })
            .catch(err => {
                console.log('error postGuestCategories post questions !',err);
                errorData.push(err);
            });
        }
    }


    return {data: {successData: successData },
            error: {errorData: errorData}};
}


export async function getGuestCategoriesForEventCategory(eventCategoryId: number): Promise<any> {
    return axios.get(process.env.VUE_APP_CJ_API_URL +'/event-categories/'+eventCategoryId+ routeName)
    .then(resp => {
        return {data: resp.data};
    })
    .catch(err => {
        console.log('error getGuestCategoriesForEventCategory !',err);
        return {error : err};
    });
}

export async function getGuestCategoriesForEvent(eventId: number): Promise<any> {
    return axios.get(process.env.VUE_APP_CJ_API_URL +'/events/'+eventId+ routeName)
    .then(resp => {
        return {data: resp.data};
    })
    .catch(err => {
        console.log('error getGuestCategoriesForEvent !',err);
        return {error : err};
    });
}